/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Location_TitleInputs */

const en_home_trust_location_title = /** @type {(inputs: Home_Trust_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Canadian`)
};

const fr_home_trust_location_title = /** @type {(inputs: Home_Trust_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% canadien`)
};

/**
* | output |
* | --- |
* | "100% Canadian" |
*
* @param {Home_Trust_Location_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_location_title = /** @type {((inputs?: Home_Trust_Location_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Location_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_location_title(inputs)
	return fr_home_trust_location_title(inputs)
});